import { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Section } from '../section';
import { SectionItem } from '../section-item';
import { questionHelpers } from '~/components';

const QUESTIONS_SECTION_NAME = 'questionsSection';

export class QuestionsDetails extends PureComponent {
  render() {
    const {
      questions: rawQuestions,
      answers,
      questionsSectionsConfig,
      history,
      match: { params: matchParams },
      appointmentDraft: { fittingTypes },
    } = this.props;

    return questionsSectionsConfig.map(({ key: sectionKey, title: sectionTitle, url }) => {
      const sectionQuestions =
        rawQuestions.RETRIEVED_QUESTIONS.filter(({ section }) => section === sectionKey) || [];

      const isFittingTypes = Object.values(fittingTypes).filter((e) => e).length > 0;

      let questions = questionHelpers.flatQuestionChildren(sectionQuestions, answers);
      if (isFittingTypes && questions.length > 0) {
        questions = [...questions.filter(({ title }) => !title.includes('Child'))];
      }
      return (
        sectionQuestions.length > 0 && (
          <Section
            key={sectionKey || sectionTitle}
            category={sectionTitle}
            editPath={`/edit-question-answers/${url || ''}`}
            history={history}
            matchParams={matchParams}
            analyticsSectionType="questions"
          >
            {questions.map((question) => {
              const answer = answers[question.reduxFieldConfig.name];
              const definition = question.formatAnswer({ answer, question }) || '-';

              return (
                <SectionItem
                  key={question.id}
                  title={question.title || question.label}
                  definition={definition}
                />
              );
            })}
          </Section>
        )
      );
    });
  }
}

export const mapStateToProps = (state) => {
  const {
    questions: { questions },
    services: {
      config: { questionsSectionsConfig },
    },
    appointment: { draft: appointmentDraft },
  } = state;

  // Access questionsSection from restoredAnswers instead of redux-form
  const answers = state.questions?.restoredAnswers?.[QUESTIONS_SECTION_NAME] || {};

  return {
    questionsSectionsConfig,
    questions,
    answers,
    appointmentDraft,
  };
};

export const ConnectedQuestionsDetailsWithRouter = withRouter(
  connect(mapStateToProps)(QuestionsDetails),
);

QuestionsDetails.propTypes = {
  questions: PropTypes.shape({}).isRequired,
  questionsSectionsConfig: PropTypes.arrayOf(PropTypes.shape({})),
  history: PropTypes.shape({}).isRequired,
  answers: PropTypes.shape({}),
  match: PropTypes.shape({}),
};

QuestionsDetails.defaultProps = {
  answers: {},
  questionsSectionsConfig: [],
  match: {},
};
